"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchSuggestions = exports.createWriter = exports.deleteDraftRightsHolder = exports.deleteAllDraftsRightsHolder = exports.worksDraftsRH = exports.worksHistoryRH = exports.getCurrentWorksFromUploadFile = exports.getCompleteWorksFromUpload = exports.saveUploadWorks = exports.getWorkCatalogById = exports.getWorkById = exports.postWork = exports.getUnclaimedWorks = void 0;
const api_client_1 = require("@App/api/api-client");
const pathes_1 = __importDefault(require("@App/dicts/pathes"));
const fetch_type_enum_1 = require("@Components/WorkItemV2/fetch-type-enum");
const getUnclaimedWorks = (pagination, search, filter) => {
    const request = Object.assign(Object.assign({}, search), filter);
    return api_client_1.axiosClient.post(pathes_1.default.RightsHolder.unclaimedSearch(pagination), request);
};
exports.getUnclaimedWorks = getUnclaimedWorks;
const postWork = (data, rightsholderId) => api_client_1.axiosClient.post(pathes_1.default.Work.postWork(rightsholderId), data);
exports.postWork = postWork;
const getWorkById = (id, type, rightsholderId) => {
    switch (type) {
        case fetch_type_enum_1.FetchType.TRANSACTION:
            return api_client_1.axiosClient.get(pathes_1.default.Work.submissionById(id, rightsholderId));
        case fetch_type_enum_1.FetchType.HFA:
            return api_client_1.axiosClient.get(pathes_1.default.Work.summaryById(id, rightsholderId));
        case fetch_type_enum_1.FetchType.MLC:
            return api_client_1.axiosClient.get(pathes_1.default.Work.workById(id, rightsholderId));
    }
};
exports.getWorkById = getWorkById;
const getWorkCatalogById = (id) => api_client_1.axiosClient.get(pathes_1.default.Work.catalogWorkById(id));
exports.getWorkCatalogById = getWorkCatalogById;
const saveUploadWorks = (rightsHolderId, works) => api_client_1.axiosClient.post(pathes_1.default.Upload.works(rightsHolderId), works);
exports.saveUploadWorks = saveUploadWorks;
const getCompleteWorksFromUpload = (rightsholderId, fileId, pagination) => {
    const request = {
        data: pagination,
    };
    return api_client_1.axiosClient.get(pathes_1.default.Upload.works(rightsholderId, fileId), request);
};
exports.getCompleteWorksFromUpload = getCompleteWorksFromUpload;
const getCurrentWorksFromUploadFile = (rightsHolderId, pagination, data) => api_client_1.axiosClient.post(pathes_1.default.Upload.files(pagination, rightsHolderId), data, {
    transformRequest: [
        (transformData, headers) => {
            if (transformData) {
                headers['Content-Type'] = 'multipart/form-data';
            }
            return data;
        },
    ],
});
exports.getCurrentWorksFromUploadFile = getCurrentWorksFromUploadFile;
const worksHistoryRH = (rightsHolderId, pagination) => api_client_1.axiosClient.get(pathes_1.default.Work.worksHistoryRH(rightsHolderId, pagination));
exports.worksHistoryRH = worksHistoryRH;
const worksDraftsRH = (rightsHolderId, pagination) => api_client_1.axiosClient.get(pathes_1.default.Work.worksDraftsRH(rightsHolderId, pagination));
exports.worksDraftsRH = worksDraftsRH;
const deleteAllDraftsRightsHolder = (rightsHolderId) => api_client_1.axiosClient.delete(pathes_1.default.Work.worksDraftsRH(rightsHolderId));
exports.deleteAllDraftsRightsHolder = deleteAllDraftsRightsHolder;
const deleteDraftRightsHolder = (draftId) => api_client_1.axiosClient.delete(pathes_1.default.Work.workDraftRH(draftId));
exports.deleteDraftRightsHolder = deleteDraftRightsHolder;
const createWriter = (writer) => api_client_1.axiosClient.post(pathes_1.default.Work.createWriter, writer);
exports.createWriter = createWriter;
const searchSuggestions = (property, searchTerm, notClaimedBy, isOverclaimable) => api_client_1.axiosClient.get(pathes_1.default.Search.searchSuggestions(property, searchTerm, notClaimedBy, isOverclaimable));
exports.searchSuggestions = searchSuggestions;
